import { v4 as uuidv4 } from 'uuid';

export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: "mobile",
    FormItemProps: {
      label: '手机号',
      name: uuid,
    },
  }
}
